export default ({ url, headers }: { url: string; headers: any }) => ({
  url,
  method: 'DELETE',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...headers
  }
});
